import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {ModListItem} from '../../mod-list-control.types';
import styles from './mod-list-sub-options.module.scss';

interface ModListSubOptionsProps {
  item: ModListItem;
  onClose: () => void;
}

export function ModListSubOptions({item, onClose}: ModListSubOptionsProps): ReactElement {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          <Icon className="ct-neutral-primary" icon={item.iconClass} size={IconSize.SIZE_ICON_20} />
          <Text val={item.label} size={TextSize.MD} className="ct-neutral-primary" />
        </div>
        <div className={styles.closeIconWrapper}>
          <Icon
            ariaLabel={window.i18next.t('pmwjs_close')}
            className="ct-neutral-primary"
            icon="icon-close"
            isUsedAsButton
            onClick={onClose}
            shape={IconShape.SQUARE}
            size={IconSize.SIZE_ICON_20}
            type={IconType.GHOST_UNCOLORED}
          />
        </div>
      </div>
      <ul className={styles.list}>
        {item.subOptions?.map((option) => (
          <li key={option.label} className={styles.subOption}>
            <button className={styles.subOptionBtn} onClick={option.cb} type="button">
              <Icon aria-hidden className="ct-neutral-primary" icon={option.icon} size={IconSize.SIZE_ICON_24} />
              <Text val={option.label} size={TextSize.MD} className={`mod-list-suboption-label ct-neutral-primary ${styles.subOptionLabel}`} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
